export default __webpack_public_path__ + "static/clubs-7ae3a626d32ea4a58c725a9e22e8684d.gif";